import { BaseRequest } from 'src/app/tools/models/dtos/base-request';import { CancelationReason } from '../../entities/control-tables/cancelation-reason';import { UserInfo } from 'src/app/tools/models/entities/user-info';


export class CancelationReasonRequest extends BaseRequest {

    cancelationReason : CancelationReason

  constructor(userInfo : UserInfo){
    super(userInfo);
	this.cancelationReason = new CancelationReason()
  }
}